import React from 'react'
import { Box, Divider, Typography } from 'components'
import { Chip } from '@material-ui/core'
import { useContent, useDiversityTags } from 'utils'

export function DemographicFilter({ filterState: state, setFilterState: setState }) {
  const { selfIdentificationTags = [], selectedDisabilities = [] } = state
  const diversityTags = useDiversityTags()
  
  // Define static disability options since we're using selectedDisabilities array
  const disabilityTags = [
    { id: 'neuro', name: 'Neurodivergent' },
    { id: 'vision', name: 'Blind or low vision' },
    { id: 'hearing', name: 'Deaf or hard-of-hearing' },
    { id: 'mobility', name: 'Living with physical disabilities requiring accommodations and/or mobility aids' },
    { id: 'chronic', name: 'Living with physical illness and/or chronic pain' },
    { id: 'intellectual', name: 'Living with intellectual disabilities' },
    { id: 'speech', name: 'Living with speech or language disabilities' }
  ]

  const onSelfIdTagChange = (tagName) => {
    const newTags = [...selfIdentificationTags]
    if (newTags.includes(tagName)) {
      setState({ ...state, selfIdentificationTags: newTags.filter(t => t !== tagName) })
    } else {
      setState({ ...state, selfIdentificationTags: [...newTags, tagName] })
    }
  }

  const onDisabilityTagChange = (tag) => {
    if (selectedDisabilities.includes(tag.name)) {
      setState({ ...state, selectedDisabilities: selectedDisabilities.filter((t) => t !== tag.name) })
    } else {
      setState({ ...state, selectedDisabilities: [...selectedDisabilities, tag.name], disabilityStatus: 'Yes' })
    }
  }

  return (
    <Box py={1.5} flex={1} flexVariant="space-between align-center" minHeight="fit-content">
      <Box display="flex" alignItems="center" flex={1} flexDirection="column">
        <Typography variant="subtitle1" style={{ marginBottom: '10px' }}>Self Identification</Typography>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="row"
          flexWrap="wrap"
          width="30dvw"
          mb={2}>
          {diversityTags && diversityTags.map((tag) => (
            <Chip 
              label={tag.name} 
              key={tag.id} 
              style={{ margin: 2 }} 
              variant={selfIdentificationTags && selfIdentificationTags.includes(tag.name) ? 'default' : 'outlined'} 
              color='primary'
              onClick={() => onSelfIdTagChange(tag.name)} 
            />
          ))}
        </Box>
        
        <Box my={2}>
          <Divider style={{ width: '100%' }} />
        </Box>
        
        <Typography variant="subtitle1" style={{ marginBottom: '10px' }}>Disability</Typography>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="row"
          flexWrap="wrap"
          width="30dvw">
          {disabilityTags.map((tag) => (
            <Chip 
              label={tag.name} 
              key={tag.id} 
              style={{ margin: 2 }} 
              variant={selectedDisabilities && selectedDisabilities.includes(tag.name) ? 'default' : 'outlined'} 
              color='primary'
              onClick={() => onDisabilityTagChange(tag)} 
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
